module.exports = sha1;


//////////////////
// WEBPACK FOOTER
// external "sha1"
// module id = dKiR
// module chunks = 0